import { createAxiosInstance } from '../utils/axiosConfig';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8083/api';

// Create axios instance with default config and interceptors
const analyticsAPI = createAxiosInstance({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const analyticsService = {
  // Get general statistics for homepage
  getHomePageStatistics: async () => {
    try {
      const response = await analyticsAPI.get('/users/analytics/public');
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Failed to fetch statistics';
      throw new Error(message);
    }
  },

  // Get user analytics
  getUserAnalytics: async () => {
    try {
      const response = await analyticsAPI.get('/users/analytics/counts');
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Failed to fetch user analytics';
      throw new Error(message);
    }
  },

  // Get order analytics
  getOrderAnalytics: async () => {
    try {
      const response = await analyticsAPI.get('/orders/analytics');
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Failed to fetch order analytics';
      throw new Error(message);
    }
  },

  // Get payment analytics
  getPaymentAnalytics: async () => {
    try {
      const response = await analyticsAPI.get('/payments/admin/analytics');
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Failed to fetch payment analytics';
      throw new Error(message);
    }
  },

  // Generate sales report
  generateSalesReport: async (params) => {
    try {
      const response = await analyticsAPI.get('/orders/reports/sales', { params });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Failed to generate sales report';
      throw new Error(message);
    }
  },

  // Generate product report
  generateProductReport: async (params) => {
    try {
      const response = await analyticsAPI.get('/products/reports/products', { params });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Failed to generate product report';
      throw new Error(message);
    }
  },

  // Generate user report
  generateUserReport: async (params) => {
    try {
      const response = await analyticsAPI.get('/users/reports/users', { params });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Failed to generate user report';
      throw new Error(message);
    }
  },

  // Get user type distribution for customer analytics
  getUserTypeDistribution: async () => {
    try {
      const response = await analyticsAPI.get('/users/analytics/user-distribution');
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Failed to fetch user type distribution';
      throw new Error(message);
    }
  },

  // Get top customers for customer analytics
  getTopCustomers: async () => {
    try {
      const response = await analyticsAPI.get('/users/analytics/top-customers');
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Failed to fetch top customers';
      throw new Error(message);
    }
  }
};

export default analyticsService;